class BoMenu extends HTMLElement {
  connectedCallback() {
    this.button = this.querySelector('[data-menu-toggle]');
    this.panel = this.querySelector('[data-menu-panel]');
    if (!this.button || !this.panel) return;
    this.button.addEventListener('click', () => this.toggle());
    this.panel.addEventListener('click', (event) => {
      if (event.target.matches('[data-menu-close]')) this.close();
    });
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') this.close();
    });
  }

  toggle() {
    const open = this.button.getAttribute('aria-expanded') === 'true';
    open ? this.close() : this.open();
  }

  open() {
    this.button.setAttribute('aria-expanded', 'true');
    this.panel.hidden = false;
    document.body.classList.add('menu-open');
  }

  close() {
    this.button.setAttribute('aria-expanded', 'false');
    this.panel.hidden = true;
    document.body.classList.remove('menu-open');
  }
}

customElements.define('bo-menu', BoMenu);
